import {JumperPiece} from "./jumperPiece";
import {ROCK_BLACK, ROCK_WHITE} from "./svg";

export class Rock extends JumperPiece {
    name = 'rock';

    directions = [[0, +1], [0, -1], [+1, 0], [-1, 0]];

    svgBlack = ROCK_BLACK;
    svgWhite = ROCK_WHITE;

    getDirections() {
        return this.directions;
    }

    clone() {
        const result = new Rock();
        super.clone(result);
        return result;
    }
}